import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { fee } from "../../rbac-consts";
import { default as AdminFeeDetailsContainer } from "./admin/fee/FeeDetailsContainer";

const ClientsFeeWrapper = ({ match }) => {

  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={fee.ADMIN}
      yes={() => (
        <AdminFeeDetailsContainer match={match} />
      )}
    />
  );
};

export default ClientsFeeWrapper;